import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import ThemeToggle from '@/components/Helper/ThemeToggle';
import AuthBackground from '@/pages/Auth/Auth-background';
import LOGO from '@/assets/images/logo-eci.png';
import OVERLAY from '@/assets/images/overlay-circle-login.png';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen w-full overflow-hidden">
      <div className="relative hidden items-center justify-center bg-[#2563EB] lg:block lg:w-1/2">
        <AuthBackground />
      </div>

      <div className="relative flex w-full flex-col bg-transparent lg:w-1/2 lg:bg-right-login">
        <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden lg:hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB] to-[#1d4ed8]" />
          <img
            src={OVERLAY}
            alt=""
            className="pointer-events-none absolute left-0 top-0 w-full opacity-90"
          />
        </div>

        <div className="relative z-20 flex items-center justify-between px-[2.4rem] pb-[3.2rem] pt-[5rem] lg:hidden">
          <img src={LOGO} alt="ECI GLOBAL" className="h-auto w-[14rem]" />
          <div className="rounded-full bg-white/20 p-[0.6rem] backdrop-blur-sm">
            <ThemeToggle />
          </div>
        </div>

        <div className="absolute right-8 top-8 z-50 hidden lg:block">
          <ThemeToggle />
        </div>

        <main className="relative z-10 flex flex-1 items-start justify-center px-[2rem] pb-[4rem] pt-[2.4rem] lg:px-8 lg:pb-0 lg:pt-[17rem]">
          <Suspense
            fallback={
              <div className="flex min-h-[32rem] w-full max-w-[48rem] items-center justify-center">
                <div className="flex items-center gap-[1.2rem] rounded-full border border-[#D7E3FF] bg-white/85 px-[2rem] py-[1.2rem] text-[#2563EB] shadow-[0_1.2rem_3.2rem_rgba(12,35,94,0.14)] backdrop-blur-md dark:border-[#2563EB66] dark:bg-[#091327]/85 dark:text-[#9BB7F6] dark:shadow-[0_1.2rem_3.2rem_rgba(0,0,0,0.32)]">
                  <span className="h-[1.8rem] w-[1.8rem] shrink-0 animate-spin rounded-full border-[0.2rem] border-current border-t-transparent" />
                  <span className="text-[1.4rem] font-semibold leading-[2rem]">Đang tải...</span>
                </div>
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
